export default {
    methods: {
        async loadingData (target, callback) {
            const loading = this.$loading({
                lock: true,
                text: '处理中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
                target: target ? target : document.body,
            });
            try {
                await callback();
            } finally {
                loading.close();
            }
        },

        confirm (msg, doConfirm, doCancel, options) {
            let defaultOpts = {
                title: '提示',
                type: 'warning',
                confirmBtnTxt: '确定',
                cancelBtnTxt: '取消',
            };
            if (options) {
                Object.assign(defaultOpts, options);
            }
            this.$confirm(msg, defaultOpts.title, {
                confirmButtonText: defaultOpts.confirmBtnTxt,
                cancelButtonText: defaultOpts.cancelBtnTxt,
                type: defaultOpts.type
            }).then(async () => {
                try {
                    if (doConfirm) {
                        await doConfirm();
                    }
                }
                catch (err) {
                    console.log(err);
                }
            }).catch(async () => {
                try {
                    if (doCancel) {
                        await doCancel();
                    }
                }
                catch (err) {
                    console.log(err);
                }
            });
        },

        alert (msg, defaultOpts) {
            let options = {
                isCustom: false,
                title: '提示',
                showCancelButton: true,
                showConfirmButton: true,
                cancelButtonText: '取消',
                confirmButtonText: '确定',
            };
            if (defaultOpts) {
                Object.assign(options, defaultOpts);
            }
            if (!options.isCustom) {
                this.$alert(msg, options.title, {
                    showConfirmButton: false,
                    callback: async action => {
                        if (action == 'cancel') {
                            options.doCancel && options.doCancel();
                        }
                        if (action == 'confirm') {
                            options.doConfirm && options.doConfirm();
                        }
                    },
                });
            } else {
                this.$alert(msg, options.title, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: options.confirmButtonText,
                    cancelButtonText: options.cancelButtonText,
                    showConfirmButton: options.showConfirmButton,
                    showCancelButton: options.showCancelButton,
                    confirmButtonClass: options.confirmButtonClass,
                    callback: async action => {
                        if (action == 'cancel') {
                            options.doCancel && options.doCancel();
                        }
                        if (action == 'confirm') {
                            options.doConfirm && options.doConfirm();
                        }
                    },
                });
            }
        },

        scrollToTop (dom, secs=0.2, scrollTop=0) {
            if (dom) {
                setTimeout(() => {
                    dom.scrollTop = scrollTop;
                }, secs * 1000);
            }
        },

    },
};
